import { setTheme } from "theme/default/setTheme";

export const color_e0b4b4 = setTheme(({ theme }) => theme.colors.color_e0b4b4);
